export enum TamperType {
  BATTERY = 0,
  LTE_JAM = 1,
  GPS_JAM = 2,
  MOVEMENT = 3,
  UNKNOWN = 255
}

export {};